import React from 'react';

export const StickySidebar = ({ navChildren, contentChildren }) => (
  <div className='w-full'>
    <div
      aria-labelledby='products-heading'
      className=''>
      <div className='flex'>
        {/* Navigation */}
        <aside className='hidden px-4 lg:w-3/12 lg:block lg:mr-4 xl:w-1/4'>
          <div className='transform sticky top-24'>{navChildren}</div>
        </aside>

        {/* Content */}
        <section className='w-full lg:w-9/12 xl:w-3/4'>
          {contentChildren}
        </section>
      </div>
    </div>
  </div>
);
